
import { Options, Vue } from "vue-class-component";
import axios from "axios";
import address, { filePath } from "@/variable";
import { useStore } from "vuex";

@Options({
  components: {},
  props: {
    job: String,
    groups: Array,
    activeIndex: Number,
  },
})
export default class List extends Vue {
  store = useStore();
  docs: Array<any> = [];
  filter1: any = {};
  filter2: any = {};
  path: string = address;
  address = address;
  filePath = address
  total: number = 0;
  show: number = 500;
  page: number = 1;
  pages: number = 0;
  sort: any = {
    month: -1,
    year: -1,
  };
  sortKey: string = "name";
  sortDir: number = 1;
  category: string = "";
  job?: string;
  groups?: Array<any>;
  activeIndex?: number;
  publicPath = "";
  tabIndex: number = -1;

  filterCode(code:string){
    return this.docs
    return this.docs.filter(o=>{
      console.log(o.group === code, o.group, code)
      return ((o.group??"").toLowerCase())===(code??"").toLowerCase()
    })
  }

  get codes() {
    try {
      return this.groups![this.tabIndex].text1.split(",");
    } catch (error) {
      return new Array(1);
    }
  }

  async uploadExcel(ev: any) {
    const Excel = require("exceljs/dist/es5/exceljs.browser");
    let self = this;
    let file = ev.target.files[0];
    const workbook = new Excel.Workbook();
    let book = await workbook.xlsx.load(file);
    let sheet = book.getWorksheet("import");
    let arr: Array<any> = [];
    sheet.eachRow(function(row: any, rowNumber: any) {
      if (rowNumber > 1 && row.getCell("A").value != null) {
        console.log(rowNumber);
        arr.push({
          job: row.getCell("A").value,
          category: row.getCell("B").value,
          group: row.getCell("C").value,
          item: row.getCell("D").value,
          isSubmit: row.getCell("E").value == "n" ? true : false,
          isApproved: row.getCell("F").value == "n" ? true : false,
          revision: row.getCell("G").value,
          submitDate: row.getCell("H").value,
          approvedDate: row.getCell("H").value,
          remark: row.getCell("I").value,
        });
      }
    });
    let promises: Array<Promise<any>> = [];
    arr.forEach((el) => {
      promises.push(axios.post(`${address}/pierschedule`, el));
    });
    Promise.all(promises).then((responses) => {
      console.log(responses);
      this.fetchData();
    });
  }

  deleteMany() {
    let promises: Array<Promise<any>> = [];
    this.docs.forEach((el) => {
      promises.push(axios.delete(`${address}/pierschedule/${el._id}`));
    });
    Promise.all(promises).then((responses) => {
      console.log(responses);
      this.fetchData();
    });
  }

  mounted() {
    try {
      console.log(this.groups);
      let foundIndex = this.groups!.findIndex((o) => o.text2 == this.$route.params.job);
      this.category = this.groups![foundIndex].name;
      this.tabIndex = foundIndex
    } catch (error) {}
    this.fetchData();
    this.publicPath = process.env.BASE_URL;
  }
  updatePaginate(i: number) {
    this.page = i;
    // console.log(this.page);
    this.fetchData();
  }
  get paginate() {
    let arr = new Array(this.pages).fill(0);
    return arr;
  }
  clearPage() {
    if (this.show == 999999999) {
      this.page = 0;
      this.fetchData();
    }
  }
  deleteItem(id: string) {
    var c = confirm("คุณแน่ใจหรือว่าต้องการลบรายการนี้");
    if (c) {
      axios.delete(`${address}/pierschedule/${id}`).then((response) => {
        this.fetchData();
      });
    }
  }
  fetchData() {
    this.docs = [];
    let sort: any = this.sort;
    let query = {
      search: {
        job: this.$route.params.job,
        // category: decodeURIComponent(this.category),
      },
      page: this.page,
      limit: this.show,
      skip: 0,
      sort,
    };
    axios.post(`${address}/pierschedules-paginate`, query).then((response) => {
      this.docs = response.data.docs;
      this.total = response.data.total;
      this.pages = Math.ceil(response.data.total / this.show);
      console.log("this.docs", this.docs)
    });
  }
}
